// Menus & Header Images
import dashboard from "../assets/images/dashboard.png";
import hrManagement from "../assets/images/hrManagementMenu.png";
import masterData from "../assets/images/masterData.png";
import logout from "../assets/images/logout.png";
import questionaryMenu from "../assets/images/questionary.png";
import allInterviewMenu from "../assets/images/allInterview.png";

// Others
import welcome from "../assets/images/welcome.png";
import loginVector from "../assets/images/login-vector1.png";
import calender from "../assets/images/calender.png";
import logo from "../assets/images/logo.png";
import smallLogo from "../assets/images/smallLogo.png";
import logow from "../assets/images/logo-white.png";
import bars from "../assets/images/bars.png";
import arrow from "../assets/images/arrow.png";
import backArrow from "../assets/images/backArrow.png";
import add from "../assets/images/addIcon.png";
import edit from "../assets/images/editIcon.png";
import deleted from "../assets/images/deleteIcon.png";
import bin from "../assets/images/bin.png";
import close from "../assets/images/close-icon.png";
import userImg from "../assets/images/userIcon.png";
import user from "../assets/images/user.png";
import noRecord from "../assets/images/noRecord.png";
import notification from "../assets/images/notification.png";
import search from "../assets/images/search.png";
import shortingArrow from "../assets/images/shortingArrow.png";
import profileImg from "../assets/images/profile.png";
import editIcon from "../assets/images/edit.png";
import AnimationLogoNormal from "../assets/images/Animation-logo-normal.png";
import AnimationLogoTp from "../assets/images/Animation-logo-tp.png";
import resumeView from "../assets/images/resume-view.png";
import uploadDocsIcon from "../assets/images/uploadDocsIcon.png";
import clear from "../assets/images/clear.png";
import rightTick from "../assets/images/righttike-white.png";
import excelIcon from "../assets/images/excel-icon.png";
import excelDownloadicon from "../assets/images/excelDownload-icon.png";


import maleicon from "../assets/images/male.png";
import femaleicon from "../assets/images/female.png";

// Count icon
import application from "../assets/images/application.png";
import shortlist from "../assets/images/shortlist.png";
import followup from "../assets/images/followup.png";
import schedule from "../assets/images/schedule.png";
import redyScheduleIcon from "../assets/images/redy.png";

import rejectedIcon from "../assets/images/rejected.png";
import allCandidateIcon from "../assets/images/allCandidate.png";
import finalizeIcon from "../assets/images/finalize.png";
import joinIcon from "../assets/images/join.png";
import closeIcon from "../assets/images/close.png";
import endArrowIcon from "../assets/images/end-arrow.png";



// Questionary icon
import textBoxIcon from "../assets/images/textbox.jpg";
import checkBoxIcon from "../assets/images/checkbox.jpg";
import radioIcon from "../assets/images/radio.jpg";
import labelIcon from "../assets/images/lable.jpg";
import dropdownIcon from "../assets/images/dropdown.jpg";
import skillsMenu from "../assets/images/skillsIcon.png";


import emailIcon from "../assets/images/emailIcon.png";
import phoneIcon from "../assets/images/phoneIcon.png";
import genderIcon from "../assets/images/genderIcon.png";
import addressIcon from "../assets/images/addressIcon.png";
import dobIcon from "../assets/images/dobIcon.png";
import experienceIcon from "../assets/images/experience.png";
import companyIcon from "../assets/images/company.png";
import companyPositionIcon from "../assets/images/companyPosition.png";

import importIcon from "../assets/images/import.png";
import femaleheader from "../assets/images/female-header.png";
import maleheader from "../assets/images/male-header.png";

import permissionIcon from "../assets/images/permission.png";
import securityIcon from "../assets/images/security.png";
import folder from "../assets/images/folder.png";
import subFolder from "../assets/images/sub-folder.png";
import subFolder1 from "../assets/images/sub-folder1.png";

import uploadIcon from "../assets/images/upload.png";

import rejecting from "../assets/images/rejecting.png";
import applicationReceived from "../assets/images/Application-received.png";
import interviweShedule from "../assets/images/interviwe-shedule.png";
import settingIcon from "../assets/images/setting.png";

export const AppIcons = {
  // Menu
  barsIcon: bars,
  dashboardMenu: dashboard,
  hrManagementMenu: hrManagement,
  masterDataMenu: masterData,
  logoutMenu: logout,
  QuestionaryMenu: questionaryMenu,
  AllInterviewMenu: allInterviewMenu,
  SkillsMenu: skillsMenu,

  Rejecting: rejecting,
  ApplicationReceived: applicationReceived,
  InterviweShedule: interviweShedule,

  // Others
  WelcomeImg: welcome,
  loginVectorImg: loginVector,
  calenderIcon: calender,
  logoImage: logo,
  logoImageW: logow,
  smallLogoImg: smallLogo,
  arrowIcon: arrow,
  BackArrowIcon: backArrow,
  addIcon: add,
  editIcon: edit,
  deleteIcon: deleted,
  BinIcon: bin,
  closeIcon: close,
  userImg: userImg,
  userIcon: user,
  noRecordImg: noRecord,
  notificationIcon: notification,
  searchIcon: search,
  shortingArrowIcon: shortingArrow,
  ProfileImg: profileImg,
  EditIcon: editIcon,
  AnimationLogoNormalImg: AnimationLogoNormal,
  AnimationLogoTpImg: AnimationLogoTp,
  resumeViewIcon: resumeView,
  uploadDocsIcon: uploadDocsIcon,
  ClearIcon: clear,
  RightTickIcon: rightTick,
  ExcelIcon: excelIcon,
  ExcelDownloadIcon: excelDownloadicon,
  // Count Icon
  AllCandidateIcon: allCandidateIcon,
  ApplicationIcon: application,
  ShortlistIcon: shortlist,
  FollowupIcon: followup,
  ScheduleIcon: schedule,
  RedyScheduleIcon: redyScheduleIcon,
  RejectedIcon: rejectedIcon,
  FinalizeIcon: finalizeIcon,
  JoinIcon: joinIcon,
  CloseIcon: closeIcon,


  MaleIcon: maleicon,
  FeMaleIcon: femaleicon,

  TextBoxIcon: textBoxIcon,
  RadioIcon: radioIcon,
  CheckBoxIcon: checkBoxIcon,
  LabelIcon: labelIcon,
  DropdownIcon: dropdownIcon,

  EmailIcon: emailIcon,
  PhoneIcon: phoneIcon,
  GenderIcon: genderIcon,
  AddressIcon: addressIcon,
  DOBIcon: dobIcon,

  ExperienceIcon: experienceIcon,
  CompanyIcon: companyIcon,
  CompanyPositionIcon: companyPositionIcon,

  ImportIcon: importIcon,
  Femaleheader: femaleheader,
  Maleheader: maleheader,
  EndArrowIcon: endArrowIcon,

  permissionIcon: permissionIcon,
  securityIcon: securityIcon,
  folderIcon: folder,
  subFolderIcon: subFolder,
  subFolder1Icon: subFolder1,

  //
  Uploaddocumenticon: uploadDocsIcon,
  UploadIcon: uploadIcon,
  SettingIcon:settingIcon,
};
